import { useMutation } from '@tanstack/react-query';

import { TasksApi } from 'api/TasksApi';
import { useFiTaskCache } from 'tanstack-hooks/fi-tasks/tasks-cache';
import { FI_TASK_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useUpdateFiTasksDueDate() {
  const { userBankId } = useUser();
  const { invalidateTaskDetails, applyTaskUpdates } = useFiTaskCache();
  const tasksApi = new TasksApi();

  const { mutateAsync: updateFiTasksDueDate, isPending: isUpdateFiTasksDueDatePending } = useMutation({
    mutationKey: [FI_TASK_KEY],
    mutationFn: ({ taskIds, dueDate }: { taskIds: string[]; dueDate: string }) =>
      tasksApi.bulkUpdateTasks(userBankId, taskIds, undefined, undefined, dueDate),
    onSuccess: (updatedTasks, { taskIds }) => {
      applyTaskUpdates(updatedTasks);
      invalidateTaskDetails(taskIds);
    },
    meta: {
      snackbarSuccessMessage: 'Due date updated successfully.',
      snackbarErrorMessage: 'There was a problem updating the due date. Please try again or contact support.'
    }
  });

  return { updateFiTasksDueDate, isUpdateFiTasksDueDatePending };
}
